export default "/dist/files/average_score.e96a7f65194f05620670f884231f37ed.svg";